import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

function AdminRegisterModal({ show, handleClose }) {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [role, setRole] = useState('admin');
    const [message, setMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);

    const navigate = useNavigate();

    const validateForm = () => {
        if (!name.trim()) return 'Name is required.';
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) return 'Please enter a valid email address.';
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_]).{8,}$/;
        if (!passwordRegex.test(password)) {
            return 'Password must be at least 8 characters long and include uppercase, lowercase, number, and special character.';
        }
        return '';
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setMessage('');

        const validationError = validateForm();
        if (validationError) {
            setMessage(validationError);
            setLoading(false);
            return;
        }

        const adminData = { name, email, password, role };

        try {
            const response = await axios.post('https://agpipefitting.org.et/api/admin-register', adminData);
            if (response.status === 201) {
                setMessage('Registration successful! Redirecting...');

                // Clear form
                setName('');
                setEmail('');
                setPassword('');

                // Close modal and redirect
                handleClose();
                setTimeout(() => {
                    navigate('/admin-login', { replace: true });
                }, 500);
            }
        } catch (error) {
            console.error('Registration Error:', error);
            let errorMessage = 'Registration failed. Please try again.';
            if (error.response?.data?.errors) {
                errorMessage = Object.values(error.response.data.errors).flat().join(' ');
            } else {
                errorMessage = error.response?.data?.message || errorMessage;
            }
            setMessage(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const handleModalClose = () => {
        setName('');
        setEmail('');
        setPassword('');
        setMessage('');
        handleClose();
    };

    return (
        <Modal show={show} onHide={handleModalClose} centered>
            <Modal.Header closeButton>
                <Modal.Title>Admin Registration</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="name" className="form-label">Name</label>
                        <input
                            type="text"
                            className="form-control"
                            id="name"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="email" className="form-label">Email</label>
                        <input
                            type="email"
                            className="form-control"
                            id="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="password" className="form-label">Password</label>
                        <div className="input-group">
                            <input
                                type={showPassword ? "text" : "password"}
                                className="form-control"
                                id="password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                required
                            />
                            <button
                                type="button"
                                className="btn btn-outline-secondary"
                                onClick={() => setShowPassword(!showPassword)}
                                tabIndex={-1}
                            >
                                {showPassword ? "Hide" : "Show"}
                            </button>
                        </div>
                    </div>
                    <div className="mb-3">
                        <label htmlFor="role" className="form-label">Role</label>
                        <select
                            className="form-control"
                            id="role"
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                        >
                            <option value="admin">Admin</option>
                            <option value="manager">Marketing Manager</option>
                            <option value="expert">StoreKeeper</option>
                            <option value="plan">Production Stock</option>
                        </select>
                    </div>
                    {message && (
                        <div className={`alert ${message.includes('success') ? 'alert-success' : 'alert-danger'}`}>
                            {message}
                        </div>
                    )}
                    <div className="d-flex justify-content-between">
                        <Button variant="secondary" onClick={handleModalClose}>
                            Close
                        </Button>
                        <Button
                            variant="primary"
                            type="submit"
                            disabled={loading}
                        >
                            {loading ? 'Registering...' : 'Register'}
                        </Button>
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    );
}

export default AdminRegisterModal;
